import Link from 'next/link';

export const FaqData = [
  {
    title: 'How do you customize pricing?',
    content: (
      <>
        Pricing is based on an annual subscription per user. A user is a person who interacts with Develocity and/or
        contributes code to a source repository that has a build connected with Develocity.
      </>
    ),
  },
  {
    title: 'I use the free Build Scan® service. Why do I need Develocity?',
    content: (
      <>
        Our free Build Scan service gives individual developers a wealth of data about each build to facilitate more
        efficient collaboration and troubleshooting. Develocity&apos;s Build Scan offers a powerful build scan
        comparison feature which performs diffs between two builds to quickly pinpoint what most likely broke the latest
        build. Develocity also offers a host of features beyond Build Scan built specifically for enterprise companies,
        including our suite of advanced build and test acceleration technologies, failure troubleshooting features, and
        greater observability through comprehensive reporting and insights on every local and CI build.
      </>
    ),
  },
  {
    title: 'Is Develocity worth the price?',
    content: (
      <>
        Yes! Two-thirds of surveyed Develocity customers saw a payback within 3 months and 40% described the payback as
        &quot;immediate&quot;. You can use our{' '}
        <Link
          onClick={e => e.stopPropagation()}
          href="#PricingRoiCalculatorSection"
          className="font-normal text-gradle-blue hover:text-core-blue hover:underline hover:underline-offset-4"
        >
          ROI calculator
        </Link>{' '}
        right now to estimate the cost-avoidance savings you can expect from faster builds and tests and more efficient
        failure troubleshooting.,
      </>
    ),
  },
  {
    title: 'How does the Free Trial work?',
    content: (
      <>
        A Free Trial is a way to see Develocity in action using your own builds and tests. Test out our acceleration
        technologies and see how we can improve failure troubleshooting and create greater observability across all
        local and CI builds. At the end of the Free Trial, a hard-cost and verifiable ROI will be generated to help you
        build a business case for Develocity. A Free Trial typically takes about two weeks and on average results in a
        50% reduction in build times, a 40% decrease in test time, and a 25% decrease in time spent troubleshooting. You
        will also have direct access to Develocity build and test engineers to learn best practices for build and test
        optimization as well as failure troubleshooting
      </>
    ),
  },
  {
    title: 'Do you have special pricing for open-source projects or educational institutions?',
    content: (
      <>
        Gradle is proud to support key open-source projects with free instances of Develocity. You can see a list of
        supported projects{' '}
        <Link
          onClick={e => e.stopPropagation()}
          href="/customers/oss-projects/"
          className="font-normal text-gradle-blue hover:text-core-blue hover:underline hover:underline-offset-4"
        >
          here
        </Link>
        . Gradle has limited resources to support these projects. However, if you represent an open-source project or
        educational institution, feel free to{' '}
        <Link
          onClick={e => e.stopPropagation()}
          href="#PricingContactUsSection"
          className="font-normal text-gradle-blue hover:text-core-blue hover:underline hover:underline-offset-4"
        >
          contact us
        </Link>{' '}
        if you are interested in exploring this further.
      </>
    ),
  },
];
